module.exports = __webpack_public_path__ + "static/img/translate.0c70ee32.gif";